// @deprecated - Use ObservationsModal (src/components/Advanced/Modal/ObservationsModal/) instead
import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { ObservationContext } from "../../../../context/ObservationContext/ObservationContext";
import useAuthUser from "../../../../hooks/useAuthUser";
import useObservationStatuses from "../../../../hooks/useObservationStatuses";

const Observation = ({ cipId }) => {
  const user = useAuthUser();
  const employeeId = user?.employeeId || user?.employee || null;
  const {
    observations,
    loading,
    error,
    setCipId,
    addObservation,
    changeObservationStatus,
  } = useContext(ObservationContext);

  const {
    OPEN: STATUS_OPEN,
    DELETED: STATUS_DELETED,
    options: STATUS_OPTIONS,
    colors: STATUS_COLORS,
  } = useObservationStatuses();

  const [newObservation, setNewObservation] = useState("");
  const [newStatus, setNewStatus] = useState(STATUS_OPEN);

  useEffect(() => {
    if (cipId) {
      setCipId(cipId);
    }
  }, [cipId]);

  const handleAddObservation = async () => {
    if (!newObservation || !newStatus) {
      alert("Please fill in both fields before submitting.");
      return;
    }

    const newEntry = {
      cipId,
      message: newObservation,
      componentId: 1,
      priority: null,
      employeeId,
      status: newStatus,
    };

    await addObservation(newEntry);
    setNewObservation("");
    setNewStatus(STATUS_OPEN);
  };

  const handleSoftDelete = async (observationId) => {
    await changeObservationStatus({
      observationId,
      newStatus: STATUS_DELETED,
      employeeId,
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        borderRadius: 2,
        overflow: "hidden",
        backgroundColor: "#f9f9f9",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Lista de observaciones */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          padding: 2,
          backgroundColor: "#fff",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
          Observations
        </Typography>
        <Divider sx={{ mb: 2 }} />
        {loading ? (
          <Typography variant="body2">Loading observations...</Typography>
        ) : error ? (
          <Typography color="error">Error loading observations</Typography>
        ) : (
          observations.map((obs) => (
            <Box
              key={obs.observationId}
              sx={{
                mb: 2,
                p: 2,
                borderRadius: 2,
                backgroundColor: "#f9f9f9",
                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                position: "relative",
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                {obs.employeeName} - {new Date(obs.createdAt).toLocaleDateString()}
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {obs.message}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: STATUS_COLORS[obs.status] || "gray",
                  fontWeight: "bold",
                }}
              >
                Status: {obs.statusName}
              </Typography>
              {obs.status !== STATUS_DELETED && (
                <Tooltip title="Soft delete">
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => handleSoftDelete(obs.observationId)}
                    sx={{ position: "absolute", top: 8, right: 8 }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          ))
        )}
      </Box>

      {/* Campo de entrada */}
      <Box
        sx={{
          padding: 2,
          borderTop: "1px solid #ddd",
          backgroundColor: "#ffffff",
          flexShrink: 0,
        }}
      >
        <TextField
          label="New Observation"
          value={newObservation}
          onChange={(e) => setNewObservation(e.target.value)}
          multiline
          rows={2}
          fullWidth
          variant="outlined"
          sx={{ mb: 2 }}
        />
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <FormControl sx={{ minWidth: 150 }}>
            <InputLabel id="status-label">Estado</InputLabel>
            <Select
              labelId="status-label"
              value={newStatus}
              onChange={(e) => setNewStatus(e.target.value)}
              label="Estado"
            >
              {STATUS_OPTIONS.map((opt) => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddObservation}
            sx={{ flexShrink: 0 }}
          >
            Send
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Observation;
